module.exports = __webpack_public_path__ + "img/2.d9b2ed51.png";